interface SeoArticleJsonLdProps {
  headline: string;
  description: string;
  url: string;
  datePublished: string;
  dateModified?: string;
  imageUrl?: string;
  authorName?: string;
}

export default function SeoArticleJsonLd({
  headline,
  description,
  url,
  datePublished,
  dateModified,
  imageUrl,
  authorName = 'Kakobuy Polska Wiki',
}: SeoArticleJsonLdProps) {
  const siteUrl = 'https://kakobuypolska.wiki';

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    description,
    url: `${siteUrl}${url}`,
    datePublished,
    dateModified: dateModified || datePublished,
    author: {
      '@type': 'Organization',
      name: authorName,
      url: siteUrl,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Kakobuy Polska Wiki',
      url: siteUrl,
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png',
      },
    },
    ...(imageUrl ? { image: imageUrl } : {}),
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${siteUrl}${url}`,
    },
    inLanguage: 'pl',
  };

  return <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>;
}